<template>
  <div class="IndexPage">
    <!-- 轮播图 - BEGIN -->
    <div class="banner-container">
      <el-carousel
        trigger="click"
        arrow="never"
        class="banner-item"
        height="100%"
        :interval="5000"
      >
        <el-carousel-item
          v-for="(item, index) in bannerList"
          :key="index"
          :style="{
            background: `url('${item.url}') #000 center no-repeat`,
            backgroundSize: 'cover',
          }"
        >
          <div class="banner-content">
            <div class="content-title">{{ item.name }}</div>
            <div
              class="content-label"
              :style="{
                marginBottom: item.describe ? '2.5rem' : '6.25rem',
              }"
            >
              {{ item.label }}
            </div>
            <div
              class="content-describe"
              :style="{
                marginBottom: item.describe ? '6.25rem' : '0',
              }"
              v-html="item.describe"
            ></div>
            <div class="content-btn-box">
              <div class="content-btn btn-apply" @click="openApplyDialog">
                免费试用
                <div class="btn-icon"></div>
              </div>
              <div class="content-btn btn-consult" @click="openContactDialog">
                立即咨询
                <div class="btn-icon"></div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 轮播图 - END -->

    <!-- 核心技术 - BEGIN -->
    <div class="technology-container">
      <div class="container-title">核心技术</div>
      <div class="container-label">1个大模型+2个AIGC产品+N个场景应用</div>
      <div class="container-pic">
        <img :src="`${$CdnServerAddress}websit/web/index_pic1.png`" />
      </div>
    </div>
    <!-- 核心技术 - END -->

    <!-- 技术能力 - BEGIN -->
    <div class="ability-container">
      <div class="container-title">数字人全栈技术能力</div>
      <div class="container-label">
        10年+算法攻关，10年+资产积累，10年+技术沉淀，10年+研发创新，10年+行业深耕
      </div>
      <div class="container-pic">
        <img :src="`${$CdnServerAddress}websit/web/index_pic2.png`" />
      </div>
    </div>
    <!-- 技术能力 - END -->

    <!-- 产品矩阵 - BEGIN -->
    <div class="product-container">
      <div class="container-title">产品矩阵</div>
      <div class="container-content">
        <div
          class="product-item"
          v-for="(item, index) in productList"
          :key="index"
        >
          <div class="item-sign">
            <img :src="item.sign" />
            <div
              class="item-tips"
              :style="{ top: item.top, right: item.right }"
            >
              {{ item.tips }}
            </div>
          </div>
          <div class="item-content">
            <div class="item-name">{{ item.name }}</div>
            <div class="item-video">
              <video :src="item.video" :ref="`video${index}`"></video>
              <div
                :class="[
                  'video-btn',
                  item.videoStaus ? 'btn-pause' : 'btn-play',
                ]"
                @click="playVideo(index)"
              ></div>
            </div>
            <div
              class="item-label"
              v-for="(labelItem1, labelIndex1) in item.label"
              :key="labelIndex1"
            >
              <div
                v-for="(labelItem2, labelIndex2) in labelItem1"
                :key="labelIndex2"
                :style="{ textAlign: labelItem1.length > 1 ? '' : 'center' }"
              >
                {{ labelItem2 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 产品矩阵 - END -->

    <!-- 合作客户 - BEGIN -->
    <div class="customer-container">
      <div class="container-title">合作客户</div>
      <div class="container-label">
        以非凡实力成为行业头部客户数字人AIGC应用的不二智选
      </div>
      <IndexMarquee :list="marqueeList[0]" :initX="0" />
      <IndexMarquee :list="marqueeList[1]" :initX="-110" />
      <IndexMarquee :list="marqueeList[2]" :initX="0" />
      <IndexMarquee :list="marqueeList[3]" :initX="-110" />
    </div>
    <!-- 合作客户 - END -->
  </div>
</template>

<script>
import { EventBus } from "@/common/event-bus";
import IndexMarquee from "@/components/indexMarquee/index.vue";
import * as IndexRequest from "@/api/index";

export default {
  name: "IndexPage",
  components: {
    IndexMarquee,
  },
  data() {
    return {
      bannerIndex: 0,
      bannerList: [],
      bannerTimer: null,
      productList: [
        {
          id: 1,
          sign: `${this.$CdnServerAddress}websit/web/logo_1.png`,
          tips: "AI实时交互",
          top: "-50%",
          right: "-75%",
          name: "数字人AIGC实时交互平台",
          video: `${this.$CdnServerAddress}websit/web/video_1.mp4`,
          videoStaus: false,
          label: [
            ["百变人设", "高精度识别", "专家级回答", "毫秒级响应"],
            ["自定义大脑训练", "多语言多方言", "大屏汇报交互", "支持独立部署"],
          ],
        },
        {
          id: 2,
          sign: `${this.$CdnServerAddress}websit/web/logo_2.png`,
          tips: "AI视频",
          top: "-50%",
          right: "-45%",
          name: "数字人AIGC视频创作平台",
          video: `${this.$CdnServerAddress}websit/web/video_2.mp4`,
          videoStaus: false,
          label: [
            ["万级素材库", "傻瓜式操作"],
            ["广播级功能", "电影级效果"],
          ],
        },
      ],
      marqueeList: [
        [
          `${this.$CdnServerAddress}websit/web/logo1.png`,
          `${this.$CdnServerAddress}websit/web/logo2.png`,
          `${this.$CdnServerAddress}websit/web/logo3.png`,
          `${this.$CdnServerAddress}websit/web/logo4.png`,
          `${this.$CdnServerAddress}websit/web/logo5.png`,
          `${this.$CdnServerAddress}websit/web/logo6.png`,
          `${this.$CdnServerAddress}websit/web/logo7.png`,
          `${this.$CdnServerAddress}websit/web/logo8.png`,
          `${this.$CdnServerAddress}websit/web/logo9.png`,
          `${this.$CdnServerAddress}websit/web/logo10.png`,
          `${this.$CdnServerAddress}websit/web/logo11.png`,
          `${this.$CdnServerAddress}websit/web/logo12.png`,
          `${this.$CdnServerAddress}websit/web/logo13.png`,
        ],
        [
          `${this.$CdnServerAddress}websit/web/logo14.png`,
          `${this.$CdnServerAddress}websit/web/logo15.png`,
          `${this.$CdnServerAddress}websit/web/logo16.png`,
          `${this.$CdnServerAddress}websit/web/logo17.png`,
          `${this.$CdnServerAddress}websit/web/logo18.png`,
          `${this.$CdnServerAddress}websit/web/logo19.png`,
          `${this.$CdnServerAddress}websit/web/logo20.png`,
          `${this.$CdnServerAddress}websit/web/logo21.png`,
          `${this.$CdnServerAddress}websit/web/logo22.png`,
          `${this.$CdnServerAddress}websit/web/logo23.png`,
          `${this.$CdnServerAddress}websit/web/logo24.png`,
          `${this.$CdnServerAddress}websit/web/logo25.png`,
          `${this.$CdnServerAddress}websit/web/logo26.png`,
        ],
        [
          `${this.$CdnServerAddress}websit/web/logo27.png`,
          `${this.$CdnServerAddress}websit/web/logo28.png`,
          `${this.$CdnServerAddress}websit/web/logo29.png`,
          `${this.$CdnServerAddress}websit/web/logo30.png`,
          `${this.$CdnServerAddress}websit/web/logo31.png`,
          `${this.$CdnServerAddress}websit/web/logo32.png`,
          `${this.$CdnServerAddress}websit/web/logo33.png`,
          `${this.$CdnServerAddress}websit/web/logo34.png`,
          `${this.$CdnServerAddress}websit/web/logo35.png`,
          `${this.$CdnServerAddress}websit/web/logo36.png`,
          `${this.$CdnServerAddress}websit/web/logo37.png`,
          `${this.$CdnServerAddress}websit/web/logo38.png`,
          `${this.$CdnServerAddress}websit/web/logo39.png`,
        ],
        [
          `${this.$CdnServerAddress}websit/web/logo40.png`,
          `${this.$CdnServerAddress}websit/web/logo41.png`,
          `${this.$CdnServerAddress}websit/web/logo42.png`,
          `${this.$CdnServerAddress}websit/web/logo43.png`,
          `${this.$CdnServerAddress}websit/web/logo44.png`,
          `${this.$CdnServerAddress}websit/web/logo45.png`,
          `${this.$CdnServerAddress}websit/web/logo46.png`,
          `${this.$CdnServerAddress}websit/web/logo47.png`,
          `${this.$CdnServerAddress}websit/web/logo48.png`,
          `${this.$CdnServerAddress}websit/web/logo49.png`,
          `${this.$CdnServerAddress}websit/web/logo50.png`,
          `${this.$CdnServerAddress}websit/web/logo51.png`,
          `${this.$CdnServerAddress}websit/web/logo52.png`,
        ],
      ],
      marqueeRaf1: null,
      translateX: [0, 0, 0, 0],
    };
  },
  mounted() {
    this.getBannerList();
  },
  methods: {
    openApplyDialog() {
      EventBus.$emit("openApplyDialog", { type: 1 });
    },
    openContactDialog() {
      EventBus.$emit("openContactDialog");
    },
    playVideo(index) {
      this.productList.forEach((pItem, pIndex) => {
        if (pIndex == index) {
          pItem.videoStaus = !pItem.videoStaus;
          if (pItem.videoStaus) {
            this.$refs[`video${pIndex}`][0].play();
          } else {
            this.$refs[`video${pIndex}`][0].pause();
          }
        } else {
          pItem.videoStaus = false;
          this.$refs[`video${pIndex}`][0].pause();
        }
      });
    },
    getBannerList() {
      IndexRequest.getBanners().then((res) => {
        if (res.data?.data && res.data?.data.length > 0) {
          let list = [];
          res.data?.data?.forEach((element) => {
            const memo = JSON.parse(element.memo);
            list.push({
              id: element.ID,
              name: element.name,
              label: memo.label,
              describe: memo.describe
                ? memo.describe.replace(/\n/g, "<br/>")
                : "",
              rank: memo.rank,
              url: element.image_url.replace(
                /http(s)?:\/\/idouwebmodels.oss-cn-hangzhou.aliyuncs.com\//,
                "https://bdbcdn.bdbdigital.com/"
              ),
            });
          });
          list.sort((a, b) => a.rank - b.rank);
          this.bannerList = list;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.IndexPage {
  width: 100%;
  position: relative;
  color: #ffffff;

  .banner-container {
    width: 100%;
    min-height: calc(~"100vh - 64px");
    position: relative;
    margin-top: 64px;

    .banner-item {
      width: 100%;
      height: calc(~"100vh - 64px");

      .banner-content {
        width: 70%;
        position: absolute;
        top: 50%;
        left: 14%;
        transform: translate(0, -50%);

        .content-title {
          font-size: 64px;
          font-weight: bold;
          margin-bottom: 40px;
        }

        .content-label {
          font-size: 24px;
        }

        .content-describe {
          font-size: 18px;
          line-height: 51px;
        }

        .content-btn-box {
          width: 312px;
          font-size: 18px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .content-btn {
            width: 134px;
            line-height: 38px;
            border: 1px solid #ffffff99;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            &:hover {
              background: #ffffff1a;
            }

            &.btn-apply {
              background: #a6000d;
              border-color: #a6000d;

              &:hover {
                background: #80000f;
                border-color: #80000f;
              }
            }

            .btn-icon {
              width: 16px;
              height: 16px;
              background: url("https://bdbcdn.bdbdigital.com/websit/web/arrow.svg")
                no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
    }

    ::v-deep .el-carousel__indicators--horizontal {
      bottom: 48px;
    }

    ::v-deep .el-carousel__indicator--horizontal {
      padding: 12px 8px;

      &:hover {
        .el-carousel__button {
          background: #a6000d;
        }
      }
    }

    ::v-deep .el-carousel__button {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: #ffffff;
    }
    ::v-deep .is-active .el-carousel__button {
      // 指示器激活按钮
      background: #a6000d;
    }

    .banner-btn-box {
      width: 68px;
      position: absolute;
      bottom: 60px;
      left: 50%;
      transform: translate(-50%);
      display: flex;
      align-items: center;
      justify-content: space-between;

      .banner-btn {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #ffffff;
        cursor: pointer;

        &.actived {
          background: #a6000d;
          border: 1px solid #a6000d;
        }
      }
    }
  }

  .technology-container {
    width: 100%;
    min-height: calc(~"100vh - 64px");
    background: url("https://bdbcdn.bdbdigital.com/websit/web/bg1.png") center
      no-repeat #000000;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .container-title {
      font-size: 64px;
      font-weight: bold;
      margin-bottom: 40px;
    }

    .container-label {
      font-size: 24px;
      margin-bottom: 60px;
    }

    .container-pic {
      width: 50%;

      img {
        width: 100%;
      }
    }
  }

  .ability-container {
    width: 100%;
    min-height: calc(~"100vh - 64px");
    background: url("https://bdbcdn.bdbdigital.com/websit/web/bg2.png") center
      no-repeat #000000;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .container-title {
      font-size: 64px;
      font-weight: bold;
      margin-bottom: 40px;
    }

    .container-label {
      font-size: 24px;
      margin-bottom: 80px;
    }

    .container-pic {
      width: 50%;

      img {
        width: 100%;
      }
    }
  }

  .product-container {
    width: 100%;
    min-height: calc(~"100vh - 64px");
    background: url("https://bdbcdn.bdbdigital.com/websit/web/bg1.png") center
      no-repeat #000000;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .container-title {
      font-size: 64px;
      font-weight: bold;
      margin-bottom: 80px;
    }

    .container-content {
      width: 73%;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-bottom: 20px;

      .product-item {
        width: calc(~"100% / 2 - 40px");
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        &:last-child {
          margin-right: 0;
        }

        .item-sign {
          width: 124px;
          margin-bottom: 40px;
          position: relative;

          img {
            width: 100%;
          }

          .item-tips {
            position: absolute;
            top: -50%;
            right: -75%;
            background: #a6000d;
            padding: 4px 9px;
            border-radius: 4px 0 4px 0;
          }
        }

        .item-content {
          width: 88%;
          border-radius: 8px;
          border: 1px solid #ffffff33;
          padding: 24px;

          .item-name {
            padding: 17px 10px;
            text-align: center;
            font-size: 24px;
            color: #ffffff;
            background: linear-gradient(180deg, #242424 0%, #24242466 100%);
            border-radius: 8px;
            margin-bottom: 24px;
          }

          .item-video {
            margin-bottom: 24px;
            position: relative;

            video {
              width: 100%;
            }

            .video-btn {
              width: 64px;
              height: 64px;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              cursor: pointer;

              &.btn-play {
                background: url("https://bdbcdn.bdbdigital.com/websit/web/icon-play.png")
                  no-repeat;
                background-size: 100% 100%;
              }

              &.btn-pause {
                display: none;
                background: url("https://bdbcdn.bdbdigital.com/websit/web/icon-pause.png")
                  no-repeat;
                background-size: 100% 100%;
              }
            }

            &:hover {
              .btn-pause {
                display: block;
              }
            }
          }

          .item-label {
            color: #bfbfbf;
            margin-bottom: 16px;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;

            div {
              border-right: 1px solid #bfbfbf;
              width: 30%;
              text-align: center;
              white-space: nowrap;

              &:last-child {
                border: none;
              }
            }
          }
        }
      }
    }
  }

  .customer-container {
    width: 100%;
    min-height: calc(~"100vh - 64px");
    background: url("https://bdbcdn.bdbdigital.com/websit/web/bg2.png") center
      no-repeat #000000;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    overflow: hidden;

    .container-title {
      font-size: 64px;
      font-weight: bold;
      margin-bottom: 40px;
    }

    .container-label {
      font-size: 24px;
      margin-bottom: 80px;
    }
  }
}
</style>